import * as React from "react";
import { SVGProps } from "react";
function SvgChipRemoveIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.313 1.628a.5.5 0 0 0 0-.708L9.08.688a.5.5 0 0 0-.707 0L5 4.06 1.627.688a.5.5 0 0 0-.707 0L.687.92a.5.5 0 0 0 0 .708L4.06 5 .687 8.374a.5.5 0 0 0 0 .707l.233.233a.5.5 0 0 0 .707 0L5 5.94l3.373 3.373a.5.5 0 0 0 .707 0l.233-.233a.5.5 0 0 0 0-.707L5.94 5l3.373-3.373Z"
        fill="#000"
        fillOpacity={0.5}
      />
    </svg>
  );
}
export default SvgChipRemoveIcon;
